import Text from 'components/commons/text';
import { styled } from 'styles';
import typography from 'styles/typography';

export const Section = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: 16,
  py: 24,
  minHeight: 400,
});

export const SectionContent = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  '@sm': {
    maxWidth: 576,
  },
  '@md': {
    maxWidth: 768,
  },
  '@lg': {
    maxWidth: 992,
  },
  '@xl': {
    maxWidth: 1200,
  },
});

export const TitleText = styled(Text, {
  ...typography.headline5,
  '@md': {
    ...typography.headline4,
  },
  mb: 8,
});

export const RefundStatusPill = styled('div', {
  display: 'flex',
  borderRadius: 999,
  width: '100%',
  px: 40,
  py: 4,
  ...typography.body4,
  '@md': {
    ...typography.body3,
    py: 10,
  },
  fontWeight: '600 !important',
  justifyContent: 'center',
  variants: {
    variant: {
      success: {
        backgroundColor: '$successBg',
        color: '$success',
      },
      pending: {
        backgroundColor: '$warningBg',
        color: '$warning',
      },
      failed: {
        backgroundColor: '$errorBg',
        color: '$error',
      },
    },
  },
});
